import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { IApplication } from '../../model/iapplication';

@Injectable()
export class AnsokanFormGroupService {

  private formGroup: UntypedFormGroup;
  private pageGroup: UntypedFormGroup;

  constructor() {
    this.formGroup = new UntypedFormGroup({});
    this.pageGroup = new UntypedFormGroup({});
  }

  public get valid(): boolean {
    return this.formGroup.valid;
  }

  public get pageValid(): boolean {
    if (this.pageGroup) {
      this.pageGroup.updateValueAndValidity();
      return this.pageGroup.valid;
    }
    return false;
  }

  public get value(): IApplication {
    return this.formGroup.getRawValue() as IApplication;
  }

  public addControl(name: string, control: AbstractControl): void {
    this.formGroup.addControl(name, control);
  }

  public setFormGroup(group: UntypedFormGroup) {
    this.formGroup = group;
  }

  public getFormGroup(): UntypedFormGroup {
    return this.formGroup;
  }

  public setPageGroup(name: string): UntypedFormGroup {
    this.pageGroup = name ? this.formGroup.get(name) as UntypedFormGroup : new UntypedFormGroup({});
    return this.pageGroup;
  }

  public get(path: string): AbstractControl {
    return this.formGroup.get(path);
  }

  public markPageGroupAsTouched(): void {
    this.pageGroup.markAllAsTouched();
  }
}
